module.exports = __webpack_public_path__ + "img/Marketing_case_pic01.00ecc992.png";